import { AllowListPhoneNumberFragment } from '@occc/graphql';

import { UpsertAllowListPhoneNumberFormValues } from './create-comment-modal.types';

export const convertAllowListPhoneNumberExistingEntityToFormValues = ({
  existingEntity,
  isCreateMode,
}: {
  existingEntity?: AllowListPhoneNumberFragment;
  isCreateMode: boolean;
}): UpsertAllowListPhoneNumberFormValues => {
  if (isCreateMode) {
    return { name: '', phoneNumber: '', reason: '' };
  }

  return {
    name: existingEntity?.name || '',
    phoneNumber: existingEntity?.phoneNumber || '',
    reason: existingEntity?.reason || '',
  };
};
